import axios from 'axios';
import CD02Card from './NL01-news-list-item.vue';
import Pagination from '../../common/pagination/pagination.vue';
import YearFilter from '../../common/year-filter/year-filter.vue';
import EventBus from '../../common/utils/event-bus';
import {PREFIX, NEWS_LIST_URL} from '../../common/utils/api';
import {LANGUAGES} from '../../common/utils/constants';

export default {
	name: 'nl01-news-list',
	components: {
		'cd02-card': CD02Card,
		'year-filter': YearFilter,
		'pagination': Pagination
	},
	props: {
		size: {
			type: String,
			required: false,
			default: '10'
		},
		layout: {
			type: String,
			required: true
		},
		categoryInEditor: {
			type: String,
			required: false
		},
		type: {
			type: String,
			required: false,
			default: ''
		},
		parentLeloLink: {
			type: String,
			required: false,
			default: ''
		},
		yearpicker: {
			type: Boolean,
			default: false
		},
		currentPageId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			list: [],
			total: 0,
			from: 0,
			currentPage: 0,
			isError: false,
			isLoading: true,
			selectedYear: null,
			category: ''
		};
	},
	created() {
		EventBus.$on('set-news-category', this.setCategory);
	},
	beforeDestroy() {
		EventBus.$off('set-news-category', this.setCategory);
	},
	mounted() {
		this.from = 0;

		if (!this.categoryInEditor) {
			const searchParams = new URLSearchParams(window.location.search);
			if (searchParams.has('category')) {
				this.setCategory(searchParams.get('category'));
			} else {
				this.getNews();
			}
		} else {
			this.category = this.categoryInEditor;
			this.getNews();
		}
	},
	computed: {
		lang() {
			return window.lang || LANGUAGES.HU;
		},
		isLangHungarian() {
			return this.lang === LANGUAGES.HU;
		}
	},
	methods: {
		yearChange(year) {
			if (this.selectedYear !== year) {
				this.selectedYear = year;
				this.from = 0;
				this.getNews();
			}
		},
		setCategory(category) {
			if (this.category !== category) {
				this.category = category;
			}
			this.getNews();
		},
		nextPage(nextPage) {
			this.from = nextPage ? (nextPage - 1) * this.size : this.from;
			this.getNews();
		},
		formatHits(hits) {
			return hits.map(item => {
				item.news.date = this.$options.filters.dateFormat(item.news.date);

				if (this.lang === LANGUAGES.EN) {
					const {categories} = window;

					item.news.tags = item.news.tags.map((tag) => {
						return Object.keys(categories).find(key => categories[key] === tag);
					});
				}

				return item;
			});
		},
		formatUrl(url) {
			if (url.startsWith('/')) {
				url = url.substring(1, url.length);
			}
			return `/${PREFIX}${url}`;
		},
		getNews() {
			const params = this.getParams();
			this.isLoading = true;

			axios.get(NEWS_LIST_URL, {params})
				.then(({data}) => {
					this.list = this.formatHits(data.hits);
					this.total = data.total;
					this.from = data.from;
					this.currentPage = Math.ceil(data.from / Number(this.size));
				})
				.catch(_err => {
					console.error('Nem sikerült betölteni a hírek listát.', _err);
					this.isError = true;
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		getParams() {
			const category = this.lang === LANGUAGES.HU ? this.category : window.categories[this.category];

			return {
				layout: this.layout || undefined,
				from: this.from,
				size: this.size,
				startYear: this.selectedYear || undefined,
				endYear: this.selectedYear ? this.selectedYear + 1 : undefined,
				category: category || undefined,
				lang: this.lang,
				type: this.type || undefined,
				currentPageId: this.currentPageId || ""
			};
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/NL01-news-list/NL01-news-list.js